import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/95 backdrop-blur-md border-b border-brand-gray py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <a 
          href="/" 
          onClick={scrollToTop}
          className="text-brand-white font-bold text-xl tracking-tight hover:opacity-80 transition-opacity"
        >
          Translation<span className="text-brand-yellow">Table</span>
        </a>
        
        <AnimatePresence>
          {isScrolled && (
            <motion.a 
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              href="https://link.nordiccrm.ca/payment-link/69ab87521e61210f3f78bc8a"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-brand-yellow text-brand-black font-bold py-2 px-6 rounded-full text-sm hover:bg-white transition-colors shadow-lg"
            >
              Get the Book — $9.99
            </motion.a>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;